<div class="zaro-admin-page">
  <ion-card>
    <ion-card-header>
      <ion-card-title>Záróértékelések szülői láthatósága</ion-card-title>
      <ion-card-subtitle>
        Globális intézményi beállítás: mikortól láthatják a gondviselők a félévi és év végi értékeléseket.
      </ion-card-subtitle>
    </ion-card-header>

    <ion-card-content>
      <ion-grid>
        <ion-row>
          <ion-col size="12" sizeMd="5">
            <ion-item class="admin-date-setting">
              <ion-label position="stacked">Félévi értékelések láthatók ettől</ion-label>
              <ion-input type="date" [(ngModel)]="zaroBeallitas.felevi_lathato_tol"></ion-input>
            </ion-item>
          </ion-col>
          <ion-col size="12" sizeMd="5">
            <ion-item class="admin-date-setting">
              <ion-label position="stacked">Év végi értékelések láthatók ettől</ion-label>
              <ion-input type="date" [(ngModel)]="zaroBeallitas.evvegi_lathato_tol"></ion-input>
            </ion-item>
          </ion-col>
          <ion-col size="12" sizeMd="2" class="admin-setting-action">
            <ion-button expand="block" color="primary" (click)="saveZaroBeallitas()">Mentés</ion-button>
          </ion-col>
        </ion-row>
      </ion-grid>

      <ion-note color="medium">
        Ha egy dátum üres, az adott záróértékelés továbbra is azonnal megjelenik a szülői oldalon.
      </ion-note>
    </ion-card-content>
  </ion-card>
</div>
